import { render, staticRenderFns } from "./Whitelabel.vue?vue&type=template&id=1666abf0"
import script from "./Whitelabel.vue?vue&type=script&lang=js"
export * from "./Whitelabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports